import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderComp from '../Header/Header';

import './reportToRabbi.css';
import utils from '../../Functions/utils';
import PnDisplay from '../PnDisplay/PnDisplay';

function ReportToRabbiComp() {
  const navigate = useNavigate();

  const [userData, setUserData] = useState({});
  const [reportData, setReportData] = useState([]);
  const [menuHeaderOpen, setMenuHeaderOpen] = useState(false);
  const [isShowPN, setIsShowPN] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
      const fetchData = async () => {
        await fetchUserData();
      };
      fetchData();
    }, []);
  
    const fetchUserData = async () => {
      try {
        const cached = localStorage.getItem('userData');
        if (cached) {
          setUserData(JSON.parse(cached));
        } else {
          const resp = await utils.requestData('GetUserData', {});
          setUserData(resp[0]);
          localStorage.setItem('userData', JSON.stringify(resp[0]));
        }
      } catch (err) {
        console.error('Error fetching userData:', err);
        setError(err.message);
      }
    };

  const setQuickRange = (days) => {
    const startDate = new Date();
    const endDate = new Date();

    endDate.setDate(startDate.getDate()  - days); // טווח קדימה

    setEndDate(startDate.toISOString().slice(0, 10));
    setStartDate(endDate.toISOString().slice(0, 10));
  };


  // const pnData = {
  //   fullName: 'יוסי לוי',
  //   motherName: 'שרה',
  //   location: 'ירושלים',
  //   tzedakaAmount: 50,
  //   tanyaChapters: 15,
  //   keptChitat: true,
  //   keptRambam: true,
  //   brachaRequest: 'הצלחה בפרנסה ובחינוך הילדים'
  // };

  const handleSubmit = async () => {
    if (!startDate || !endDate) {
      alert('אנא מלא את שני התאריכים');
      return;
    }

    try {
      const resp = await utils.requestData('GenerateReportToRabbi', { startDate, endDate });
      const raw = resp[0];
      if (!raw) {
        throw new Error('לא התקבלו נתונים מהשרת');
      }

      const jsonText = raw['jsonResult']; 
      const parsed = JSON.parse(jsonText);

      // console.log(parsed);
      setReportData(parsed);

      setIsShowPN(true)
       

    } catch (error) {
      console.error('שגיאה:', error);
      alert(error?.message || 'שגיאה בשליחת הדוח');
    }

  };

  return (
    <div className="tanya-container">
      <HeaderComp
        userData={userData}
        menuHeaderOpen={menuHeaderOpen}
        setMenuHeaderOpen={setMenuHeaderOpen}
      />

      {/* <h1 className="page-title">דוח לרבי</h1> */}

      {
        !isShowPN ?
        <div>

        <div className="report-intro">
          <h3>דיווח לרבי</h3>
          <p>
            הרבי עודד את החסידים לדווח על פעילותם על מנת לגרום נחת רוח לרבי ולחזק את הקשר הפנימי איתו.<br /><br />
            באפשרותך ליצור דוח לימוד ומעשים טובים לפי תאריכים מותאמים אישית,<br />
            ואנו נכין עבורך קובץ פ"נ (פדיון נפש) מוכן לשליחה לרבי.
          </p>
        </div>



        <div className="date-inputs">
          <label>
            מתאריך:
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          </label>

          <label>
            עד תאריך:
            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
          </label>
        </div>

        <div className="quick-range-buttons">
          <button onClick={() => setQuickRange(1)}>היום האחרון</button>
          <button onClick={() => setQuickRange(7)}>שבוע אחרון</button>
          <button onClick={() => setQuickRange(30)}>חודש אחרון</button>
        </div>

        <button className="button" onClick={handleSubmit} style={{ marginTop: 20 }}>
          צור דוח
        </button>
          </div>
          :
          <PnDisplay reportData={reportData} userData={userData} startDate={startDate} endDate={endDate}/>
      }


      <button className="button" onClick={() => navigate('/tanya')} style={{ marginTop: 10 }}>
        ⬅ חזור
      </button>
    </div>
  );
}

export default ReportToRabbiComp;
